export default __webpack_public_path__ + "static/media/orange.3132a800.png";